import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import Button from '../../common/components/Button';
import Link from '../../common/components/Link';
import LinkButton from '../../common/components/LinkButton';
import Switch from '../../common/components/Switch';
import punctuateSeries from '../../common/helpers/punctuateSeries';
import listItems from '../../common/helpers/listItems';
import ItemList from '../../common/utils/ItemList';
import LoadingModal from './LoadingModal';
import ExtensionPermissionGrid from './ExtensionPermissionGrid';
import isExtensionEnabled from '../utils/isExtensionEnabled';
import AdminPage from './AdminPage';
import ReadmeModal from './ReadmeModal';
import extractText from '../../common/utils/extractText';
import Form from '../../common/components/Form';
import Icon from '../../common/components/Icon';
import { MaintenanceMode } from '../../common/Application';
import InfoTile from '../../common/components/InfoTile';
import Alert from '../../common/components/Alert';
export default class ExtensionPage extends AdminPage {
  constructor() {
    super(...arguments);
    _defineProperty(this, "extension", void 0);
    _defineProperty(this, "changingState", false);
    _defineProperty(this, "infoFields", {
      discuss: 'fas fa-comment-alt',
      documentation: 'fas fa-book',
      support: 'fas fa-life-ring',
      website: 'fas fa-link',
      donate: 'fas fa-donate',
      source: 'fas fa-code'
    });
  }
  oninit(vnode) {
    super.oninit(vnode);
    const extension = app.data.extensions[this.attrs.id];
    if (!extension) {
      return m.route.set(app.route('dashboard'));
    }
    this.extension = extension;
  }
  className() {
    if (!this.extension) return '';
    return this.extension.id + '-Page';
  }
  view(vnode) {
    var _app$data$safeModeExt;
    if (!this.extension) return null;
    const isAbandoned = this.extension.abandoned;
    const hasReplacement = typeof isAbandoned === 'string';
    return m("div", {
      className: 'ExtensionPage ' + this.className()
    }, this.header(), isAbandoned && m("div", {
      className: "container"
    }, m("div", {
      className: "Alert Alert--".concat(hasReplacement ? 'danger' : 'warning')
    }, m("span", {
      className: "Alert-body"
    }, hasReplacement ? app.translator.trans('core.admin.extension.abandoned_with_replacement', {
      replacement: isAbandoned
    }) : app.translator.trans('core.admin.extension.abandoned_no_replacement')))), app.data.maintenanceMode === MaintenanceMode.SAFE_MODE && !((_app$data$safeModeExt = app.data.safeModeExtensions) != null && _app$data$safeModeExt.includes(this.extension.id)) ? m("div", {
      className: "container"
    }, m("div", {
      className: "ExtensionPage-body"
    }, m(InfoTile, {
      icon: "fas fa-exclamation-triangle",
      type: "warning"
    }, app.translator.trans('core.admin.extension.safe_mode_warning')))) : this.body(vnode));
  }
  body(vnode) {
    const supportsDbDriver = !this.extension.extra['flarum-extension']['database-support'] || this.extension.extra['flarum-extension']['database-support'].map(driver => driver.toLowerCase()).includes(app.data.dbDriver.toLowerCase());
    return this.isEnabled() ? m("div", {
      className: "ExtensionPage-body"
    }, !supportsDbDriver && m(Alert, {
      type: "error",
      dismissible: false
    }, app.translator.trans('core.admin.extension.database_driver_mismatch')), this.sections(vnode).toArray()) : m("div", {
      className: "container"
    }, m("h3", {
      className: "ExtensionPage-subHeader"
    }, app.translator.trans('core.admin.extension.enable_to_see')));
  }
  header() {
    const isEnabled = this.isEnabled();
    return [m("div", {
      className: "ExtensionPage-header"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "ExtensionTitle"
    }, m("span", {
      className: "ExtensionIcon",
      style: this.extension.icon
    }, !!this.extension.icon && m(Icon, {
      name: this.extension.icon.name
    })), m("div", {
      className: "ExtensionName"
    }, m("h2", null, this.extension.extra['flarum-extension'].title)), m("div", {
      className: "ExtensionPage-headerTopItems"
    }, m("ul", null, listItems(this.topItems().toArray())))), m("div", {
      className: "helpText"
    }, this.extension.description), m("div", {
      className: "ExtensionPage-headerItems"
    }, m(Switch, {
      state: this.changingState ? !isEnabled : isEnabled,
      loading: this.changingState,
      onchange: this.toggle.bind(this, this.extension.id)
    }, isEnabled ? app.translator.trans('core.admin.extension.enabled') : app.translator.trans('core.admin.extension.disabled')), m("aside", {
      className: "ExtensionInfo"
    }, m("ul", null, listItems(this.infoItems().toArray()))))))];
  }
  sections(vnode) {
    const items = new ItemList();
    items.add('content', this.content(vnode));
    items.add('permissions', m("div", {
      className: "ExtensionPage-permissions"
    }, m("div", {
      className: "ExtensionPage-permissions-header"
    }, m("div", {
      className: "container"
    }, m("h2", {
      className: "ExtensionTitle"
    }, app.translator.trans('core.admin.extension.permissions_title')))), m("div", {
      className: "container"
    }, app.registry.extensionHasPermissions(this.extension.id) ? m(ExtensionPermissionGrid, {
      extensionId: this.extension.id
    }) : m("h3", {
      className: "ExtensionPage-subHeader"
    }, app.translator.trans('core.admin.extension.no_permissions')))));
    return items;
  }
  content(vnode) {
    const settings = app.registry.getSettings(this.extension.id);
    return m("div", {
      className: "ExtensionPage-settings"
    }, m("div", {
      className: "container"
    }, settings ? m(Form, null, settings.map(this.buildSettingComponent.bind(this)), m("div", {
      className: "Form-group Form-controls"
    }, this.submitButton(), this.resetButton(settings.filter(e => typeof e !== 'function').map(e => ({
      key: e.setting,
      label: e.label
    })), app.translator.trans('core.admin.extension.reset_settings.title_extension', {
      extensionTitle: this.extension.extra['flarum-extension'].title
    }, true), this.extension.id))) : m("h3", {
      className: "ExtensionPage-subHeader"
    }, app.translator.trans('core.admin.extension.no_settings'))));
  }
  topItems() {
    const items = new ItemList();
    items.add('version', m("span", {
      className: "ExtensionVersion"
    }, this.extension.version));
    if (!this.isEnabled()) {
      const purge = () => {
        if (confirm(extractText(app.translator.trans('core.admin.extension.confirm_purge')))) {
          app.request({
            url: app.forum.attribute('apiUrl') + '/extensions/' + this.extension.id,
            method: 'DELETE'
          }).then(() => window.location.reload());
          app.modal.show(LoadingModal);
        }
      };
      items.add('uninstall', m(Button, {
        icon: "fas fa-trash-alt",
        className: "Button Button--primary",
        onclick: purge.bind(this)
      }, app.translator.trans('core.admin.extension.purge_button')));
    }
    return items;
  }
  infoItems() {
    var _links$authors, _this$extension$extra;
    const items = new ItemList();
    const links = this.extension.links;
    if ((_links$authors = links.authors) != null && _links$authors.length) {
      const authors = links.authors.map(author => m(Link, {
        href: author.link,
        external: true,
        target: "_blank"
      }, author.name));
      items.add('authors', [m(Icon, {
        name: 'fas fa-user'
      }), m("span", null, punctuateSeries(authors))]);
    }
    Object.keys(this.infoFields).map(field => {
      if (links[field]) {
        items.add(field, m(LinkButton, {
          href: links[field],
          icon: this.infoFields[field],
          external: true,
          target: "_blank"
        }, app.translator.trans("core.admin.extension.info_links.".concat(field))));
      }
    });
    let supportedDatabases = (_this$extension$extra = this.extension.extra['flarum-extension']['database-support']) != null ? _this$extension$extra : null;
    if (supportedDatabases && supportedDatabases.length) {
      supportedDatabases = supportedDatabases.map(database => {
        return {
          mysql: 'MySQL',
          sqlite: 'SQLite',
          pgsql: 'PostgreSQL'
        }[database] || database;
      });
      items.add('database-support', m("span", {
        className: "LinkButton"
      }, m(Icon, {
        name: "fas fa-database"
      }), supportedDatabases.join(', ')));
    }
    const extension = this.extension;
    items.add('readme', m(Button, {
      icon: "fab fa-readme",
      className: "Button Button--text",
      onclick: () => app.modal.show(ReadmeModal, {
        extension
      })
    }, app.translator.trans('core.admin.extension.readme.button_label')), 10);
    return items;
  }
  toggle() {
    const enabled = this.isEnabled();
    this.changingState = true;
    app.request({
      url: app.forum.attribute('apiUrl') + '/extensions/' + this.extension.id,
      method: 'PATCH',
      body: {
        enabled: !enabled
      },
      errorHandler: this.onerror.bind(this)
    }).then(() => {
      if (!enabled) localStorage.setItem('enabledExtension', this.extension.id);
      window.location.reload();
    }).catch(() => {});
    app.modal.show(LoadingModal);
  }
  isEnabled() {
    return isExtensionEnabled(this.extension.id);
  }
  onerror(e) {
    var _e$response;
    app.modal.close();
    this.changingState = false;

    // If it's not a conflict error, use the default request error handler.
    if (e.status !== 409) {
      return false;
    }
    const error = (_e$response = e.response) == null || (_e$response = _e$response.errors) == null ? void 0 : _e$response[0];
    if (error) {
      var _error$extensions;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans("core.lib.error.".concat(error.code, "_message"), {
        extension: error.extension,
        extensions: (_error$extensions = error.extensions) == null ? void 0 : _error$extensions.join(', ')
      }));
    }
  }
}
flarum.reg.add('core', 'admin/components/ExtensionPage', ExtensionPage);